import React, { useEffect, useRef } from "react";
import ChartsEmbedSDK from "@mongodb-js/charts-embed-dom";

const MongoDBChart = ({
	resourceId,
	isDashboard,
	baseUri,
	token,
	filter,
	preFilter
}) => {
	const ref = useRef(null);

	useEffect(() => {
		if (!resourceId || !baseUri || !token) return;

		async function render() {
			try {
				ref.current.innerHTML = "";

				if (isDashboard) {
					// DASHBOARD
					const sdk = new ChartsEmbedSDK({
						baseUrl: baseUri,
						getUserToken: () => token,
					});

					const dashboard = sdk.createDashboard({
						dashboardId: resourceId,
						theme: "light",
						filter,
						showAttribution: false,
					});

					await dashboard.render(ref.current);
				} else {
					// CHART
					const sdk = new ChartsEmbedSDK({
						baseUrl: baseUri,
						dashboardId: resourceId,
						getUserToken: () => token,
					});

					const chart = sdk.createChart({
						chartId: resourceId,
						theme: "light",
						height: "100%",
						width: "100%",
						filter,
						preFilter,
						showAttribution: false
					});

					await chart.render(ref.current);
				}
			} catch (err) {
				console.error("MongoDB Charts render error:", err);
			}
		}

		render();
	}, [resourceId, isDashboard, baseUri, token, filter, preFilter]);

	return <div ref={ref} style={{ height: "100%", width: "100%" }} />;
};

export default MongoDBChart;
